import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const painPoints = [
  "Messaging feels inconsistent",
  "Positioning shifts constantly",
  "Growth becomes reactive",
  "Design becomes decoration",
];

export const Problem = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="relative">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div
        ref={ref}
        className={`max-w-[1180px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px] transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-[60px]">
          {/* Left Column */}
          <div>
            <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[#0A0A0A]">
              Most brands don't fail because of bad design.
            </h2>
            <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[rgba(10,10,10,0.3)] mt-4">
              They fail because of unclear thinking.
            </h2>
          </div>

          {/* Right Column */}
          <div>
            <p className="text-[clamp(16px,2vw,18px)] leading-[1.65] text-[rgba(10,10,10,0.5)] mb-8">
              Founders often move fast - product, marketing, growth - but the
              foundation stays undefined.
            </p>

            <ul className="space-y-4 mb-8">
              {painPoints.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 text-[clamp(16px,2vw,18px)] leading-[1.6] text-[rgba(10,10,10,0.5)]"
                >
                  <span className="mt-[11px] w-[5px] h-[5px] rounded-full bg-[rgba(10,10,10,0.2)] flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <p className="text-[clamp(16px,2vw,18px)] leading-[1.6] text-[#0A0A0A] font-medium">
              We step in before confusion compounds.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
